import React from 'react';
import './WaitingIndicator.css';

/**
 * WaitingIndicator Component
 * 
 * A premium, branded waiting indicator for asynchronous tasks (especially AI generation).
 * Features a central logo with a revolving outer ring and icons.
 * 
 * @param {string} message - Optional message to display below the indicator
 * @param {boolean} fullPage - Whether to display as a full-page overlay
 * @param {string} size - Size of the indicator ('small', 'medium', 'large')
 */
const WaitingIndicator = ({
  message = 'Generating your itinerary...',
  fullPage = false,
  size = 'medium',
  color = 'var(--itineri-blue, #3A86AD)' // Use brand color with user's blue as fallback
}) => {
  // Map size labels to pixel values
  const sizeMap = {
    'small': 48,
    'medium': 120,
    'large': 220
  };

  const svgSize = sizeMap[size] || 120;

  return (
    <div className={`waiting-indicator-container ${fullPage ? 'full-page' : ''} indicator-${size}`}>
      <div className="branding-spinner-wrapper">
        <svg
          width={svgSize}
          height={svgSize}
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="Loading"
          className="itineri-svg-spinner"
        >
          {/* Rotating ring + dot */}
          <g className="spin-group">
            {/* Ring: dash 380, gap ~85 (matches circumference at r=74) */}
            <circle
              cx="100"
              cy="100"
              r="74"
              fill="none"
              stroke={color}
              strokeWidth="10"
              strokeLinecap="round"
              strokeDasharray="380 85"
              className="spinner-ring"
            />

            {/* Dot: trails behind the ring */}
            <circle
              cx="174"
              cy="100"
              r="7"
              fill={color}
              transform="rotate(320 100 100)"
              className="spinner-dot"
            />
          </g>

          {/* Static center text */}
          <text
            x="100"
            y="108"
            textAnchor="middle"
            className="brand-text"
            style={{ fill: color }}
          >
                        itineri
          </text>
        </svg>
      </div>

      {message && <p className="waiting-message">{message}</p>}
    </div>
  );
};

export default WaitingIndicator;
